<template>
  <div>
    <el-container>
      <el-header style="height: 10px">
      </el-header>
      <el-main style="margin: 1px">
        <div class="tableBox">
          <el-table :data="tableData" stripe header-cell-class-name="tableThStyle" ref="form" empty-text="No Data">
            <el-table-column align="center" type="index" :index="indexMethod" width="80" min-width="50"
              :label="$t('records.serialNum')"></el-table-column>
            <el-table-column align="center" prop="customer_code" min-width="100" :label="$t('records.customerCode')">
            </el-table-column>
            <el-table-column align="center" prop="stores" min-width="100" :label="$t('records.stores')">
              <!-- <template slot-scope="scope">
                {{
                  scope.row.realm == "门店操作员"
                  ? $t("label.NORMAL")
                  : $t("label.ADMIN")
                }}
              </template> -->
            </el-table-column>
            <el-table-column align="center" prop="sku" min-width="100" :label="$t('records.sku')">
            </el-table-column>
            <el-table-column align="center" prop="create_date" min-width="120" :label="$t('records.createDate')"
              show-overflow-tooltip>
              <template slot-scope="scope">
                {{ dateFormat(scope.row.create_date) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paginationOut">
          <el-pagination background layout="prev, pager, next,jumper,sizes,total" popper-class="pageSizeSelect"
            :page-sizes="pagination.pageSizeOption" :page-size.sync="pagination.pageSize" :total="pagination.total"
            :current-page.sync="pagination.currentPage" @size-change="handleSizeChange"
            @current-change="handleCurrentChange"></el-pagination>
        </div>
      </el-main>

      <el-footer> </el-footer>
    </el-container>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      searchData: {
        from: 0,
        pageSize: 10,
      },
      tableData: [],
      pagination: {
        total: null,
        pageSize: 10,
        currentPage: 1,
        pageSizeOption: [10, 20, 50],
      },
    };
  },
  methods: {
    handleSizeChange: function (pageSize) {
      this.pagination.pageSize = pageSize;
      this.handleCurrentChange(this.pagination.currentPage);
    },
    handleCurrentChange: function (currentPage) {
      this.pagination.currentPage = currentPage;
      this.initRecords(this.pagination.pageSize, this.pagination.currentPage);
    },
    dateFormat: function (date) {
      return moment.utc(date).local().format("YYYY-MM-DD HH:mm:ss");
    },
    initRecords(pageSize, currentPage) {
      this.searchData.from = (currentPage - 1) * pageSize,
      this.searchData.pageSize = pageSize,
      this.getRecords(this.searchData);
      this.getRecordsCount(this.searchData);
    },
    // 获取门店列表
    getRecords(data) {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getRecords(localStorage.getItem(localStorage.getItem("integration-username")),data)
          .then((res) => {
            this.tableData = res;
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 获取门店数量
    getRecordsCount(data) {
      return new Promise((resolve, reject) => {
        this.$httpList
          .getRecordsNum(localStorage.getItem(localStorage.getItem("integration-username")),data)
          .then((res) => {
            this.pagination.total = res;
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    indexMethod(index) {
      return (
        this.pagination.pageSize * (this.pagination.currentPage - 1) + index + 1
      );
    },
  },

  created() {
    this.initRecords(this.pagination.pageSize, this.pagination.currentPage);
  },
};
</script>